import React, { useState, useContext } from "react"
import { useParams } from "react-router-dom"
import PageWrap from "../components/Page"
import { Document, Page, pdfjs } from "react-pdf"
import Loading from "../components/Loading"
import StateContext from "../StateContext"
import { SizeMe } from "react-sizeme"
import ItemMenu from "../components/ItemMenu"
import Controls from "../components/Controls"

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function Brochure() {
  const appState = useContext(StateContext)

  const url = appState.devMenuItems.brochure
  const items = appState.devMenuItems.brochures

  const id = useParams().id
  const currentItem = id ? items.find((el) => el.slug === id) : null

  //check for single or multiple items
  let currentURL = ""
  if (url) {
    currentURL = url
  } else if (items) {
    currentURL = id ? currentItem.url : items[0].url
  }

  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  function prev() {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1)
    }
  }

  function next() {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1)
    }
  }

  return (
    <PageWrap title="Brochure" fluid={false} container={false}>
      {url || (currentItem && currentItem.url) || (items && items[0].url) ? (
        <SizeMe
          monitorHeight={true}
          refreshRate={128}
          refreshMode={"debounce"}
          render={({ size }) => (
            <div className="resize-container">
              <div style={{ maxWidth: size.width, maxHeight: size.height }}>
                <Document
                  file={currentURL}
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={Loading}
                  renderMode={"canvas"}
                >
                  <Page
                    pageNumber={pageNumber}
                    height={size.width > size.height ? size.height - 60 : null}
                    width={size.width > size.height ? null : size.width - 50}
                    renderTextLayer={false}
                  />
                </Document>
              </div>
            </div>
          )}
        />
      ) : null}

      {numPages > 1 ? (
        <div className="pdf-controls">
          <button
            onClick={prev}
            className="btn btn-secondary"
            disabled={pageNumber === 1 ? true : false}
          >
            Prev
          </button>
          <span className="page-status">
            {pageNumber} of {numPages}
          </span>
          <button
            onClick={next}
            className="btn btn-secondary"
            disabled={pageNumber === numPages ? true : false}
          >
            Next
          </button>
        </div>
      ) : null}

      <div className="sub-menu high">
        <div className="container">
          {items ? (
            <ItemMenu
              items={items}
              currentItem={id ? currentItem.slug : items[0].slug}
              route="brochure"
              label="Brochures"
            />
          ) : null}
        </div>
      </div>
      <Controls />
    </PageWrap>
  )
}

export default Brochure
